import { createStore } from 'vuex';
import userModule from './modules/userModule';
import articleModule from './modules/articleModule';
import hashModule from './modules/hashModule';
import appModule from './modules/appModule';
import collectionModule from './modules/collectionModule';
import channelModule from './modules/channelModule';
import materialModule from './modules/materialModule';
import segmentModule from './modules/segmentModule';
import tgConnectorModule from './modules/tgConnectorModule';
import narezkaModule from './modules/narezkaModule';
import transactionsModule from './modules/transactionsModule';
import searchModule from './modules/searchModule';
import materialFilterModule from './modules/materialFilterModule';
import shlokaModule from './modules/shlokaModule';
import historyModule from './modules/historyModule';
import videoPlayerModule from './modules/videoPlayerModule';
import meetingModule from './modules/meetingModule';
import meetingsDashboardModule from './modules/meetingsDashboardModule';
import zvonalitikDashboardModule from './modules/zvonalitikDashboardModule';
import zvonalitikProfilesModule from './modules/zvonalitikProfilesModule';
import apiModule from './modules/apiModule';
import subscriptionModule from './modules/subscriptionModule';

const store = createStore({
  modules: {
    hash: hashModule,
    user: userModule,
    article: articleModule,
    segment: segmentModule,
    app: appModule,
    collection: collectionModule,
    channel: channelModule,
    material: materialModule,
    tgconnector: tgConnectorModule,
    narezka: narezkaModule,
    transactions: transactionsModule,
    search: searchModule,
    materialFilter: materialFilterModule,
    shloka: shlokaModule,
    history: historyModule,
    videoPlayer: videoPlayerModule,
    meeting: meetingModule,
    meetingsDashboard: meetingsDashboardModule,
    zvonalitikDashboard: zvonalitikDashboardModule,
    zvonalitikProfiles: zvonalitikProfilesModule,
    api: apiModule,
    subscription: subscriptionModule
  },
  state: {
    // Global state if needed
  },
  mutations: {
    // Global mutations if needed
  },
  actions: {
    // Global actions if needed
  },
  getters: {
    // Global getters if needed
  },
});

// 2026-09-09 (V2T-22): $axiosInstance убран. Он создавал цикл импортов
// store/index.js -> lib/axiosConfig.js -> store/index.js, и при таком порядке
// вычисления модулей axiosConfig на момент присваивания ещё undefined —
// проверено на проде: store.$axiosInstance === undefined. Значение никто не
// читал, его только передавали как payload в dispatch, где оно и выстрелило:
// экшен generateGoogleDoc разворачивает { materialId } и падал на undefined.
// Все модули импортируют axiosConfig напрямую — свойство было лишним.

export default store;
